<template>
<div @click="wrocclick">
	<div class="border" @click="wrocclick">
	<div id="barcode" class="barcodeStyle">
		<ejs-barcodegenerator
			id="barcode"
			ref="barcodeControl"
			:width="width"
			:height="height"
			:type="type"
			:value="getNumerPz()"
			:mode="mode"
			></ejs-barcodegenerator>
	</div>
	<div class="borderin3">Towar: <strong>{{ getTowar() }}</strong></div>
	<div class="borderin1">Dostawca: <strong>{{ getDostawca() }}</strong></div>
	<div class="borderin2">Data dostawy: <strong>{{ getDataDostawy() }}</strong></div>
	<div class="borderin4">Ilość skrzyń: <strong>{{ getSkrzynia() }}</strong></div>
	</div>
	<div class="divwroc" @click="wrocclick">
		<!-- <br/>
		<button class="wlabel"> WRÓĆ </button> -->
	</div>
</div>
</template>



<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from '@syncfusion/ej2-vue-barcode-generator';
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(BarcodeGeneratorPlugin);

export default {
	name: 'etykieta',
	props: {
	},
	data: ()=>({
	  dselected: [],
	  data: [],
	  datask: [],
          width: "200px",
          height: "104px",
          mode: "SVG",
          type: "Code128",
	  ident: 0,
	  jwt: "",
	}),
	methods: {
		getTowar() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].nazwaArtykulu;
			} else {
				return "";
			}
		},
		getDostawca() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].nazwaKontrahenta;
			} else {
				return "";
			}
		},
		getDataDostawy() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].dataPZ.substring(0, 10);
			} else {
				return "";
			}
		},
		getNumerPz() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].numerPZ;
			} else {
				return "";
			}
		},
		getSkrzynia() {
			if (this.datask.length > 0) {
				return "" + this.datask[0].iloscSkrzyn;
			} else {
				return "";
			}
		},
		getData(customurl) {
	  	var url = "/agent/GALEK.Magazyn/GetDokumentPZ";
		if (customurl) {
			url = customurl;
		}
                return axios
                        .get(CONFIG.API_URL + url, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        	},
		wrocclick() {
			this.$router.push({ path: "/dokumentypz" });
		},
	},
	mounted() {
		var params = this.$route.query;
		var id = "";
		if (params["item"]) {
			id = params["item"];
			this.ident = id;
		}
        	var that = this;
		var selected = [];
        	Storage.loadJWT("jwt").then(resp => {
                	//alert(resp.access_token);
                	that.jwt = resp.access_token;
        		this.getData().then(data => {
                		that.data = data;
				if (id !== "") {
					selected = that.data.filter(function(item) {
						if (item.ID_DOK_MAGAZYNOWEGO == id) return true;
						else return false;
					});
					that.dselected.push(selected.pop());
					//alert(JSON.stringify(that.dselected));
					this.getData("/agent/GALEK.Magazyn/GetIloscSkrzyn/" + id).then(data => {
						that.datask = data;
					});
					setTimeout(myprint, 1000);
				}
        		});
        	});
	}
}

function myprint() {
	window.print();
}
</script>

<style>
.wroc {
        width: 200px;
        height: 150px;
        text-align: left;
        float: left;
}
.barcodeStyle {
        height: 110px;
        width: 200px;
    }
.border {
	border: 1px solid green; 
	width: 200px;
	height: 278px;
}
.borderin1 {
	width: 200px;
	height: 80px;
}
.borderin2 {
	width: 200px;
	height: 20px;
}
.borderin3 {
	width: 200px;
	height: 40px;
}
.borderin4 {
	width: 200px;
	height: 20px;
}
.borderin5 {
	border: 1px solid black; 
	width: 200px;
	height: 50px;
	float: right;
	padding: 2% 2% 2% 2%;
	margin: 2% 2% 5% 2%;
	position: relative;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
.print {
        margin-left: 0px;
	margin-top: 140px;
}
.divwroc{
	width: 100%;
	height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/EtykietaDrukuj.vue